import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { colors, shadows } from "../../../theme/theme";

export const StyledCardBox = styled(Box, {
  shouldForwardProp: (prop) => !["isClickable"].includes(prop),
})(({ theme, isClickable }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  height: "100%",
  padding: theme.spacing(2, 3),
  backgroundColor: "#fff",
  borderRadius: "30px",
  boxShadow: shadows.card,
  cursor: isClickable ? "pointer" : "default",
  minHeight: "150px",
  [theme.breakpoints.down("md")]: {
    minHeight: "120px",
  },
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  ...(isClickable && {
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: shadows.cardHover,
    },
  }),
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Gotham', sans-serif",
  fontWeight: 500,
  fontSize: "22px",
  maxWidth: "85%",
  letterSpacing: "0.2px",
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
}));

export const iconSx = {
  fontSize: "24px",
  color: colors.secondary,
};
